export default function elmntIO($el = null, callbackEnter = null, callbackExit = null) {

    if ( !$el ) return;

    if ( !('io' in $el.dataset) ) {
        $el.dataset.io = 'once';
    }

    // options
    let ioTreshold = 0.15;
    if ( 'ioThreshold' in $el.dataset && $el.dataset.ioThreshold ) {
        ioTreshold = parseFloat($el.dataset.ioThreshold);
    }

    let ioViewportY = null;
    if ( 'ioViewportY' in $el.dataset ) {
        ioViewportY = ($el.dataset.ioViewportY) ? parseFloat($el.dataset.ioViewportY) : 50;
    }

    let ioYOffset = 50;
    if ( 'ioYOffset' in $el.dataset && $el.dataset.ioYOffset ) {
        ioYOffset = parseFloat($el.dataset.ioYOffset);
    }


    // IntersectionObserver Options
    const ioOptions = {
        threshold: ioTreshold
    };

    // custom options
    const customOptions = {
        viewportY: ioViewportY,
        yOffset: ioYOffset
    };


    // init io
    let io = new IntersectionObserver(handleIoEntry, ioOptions);
    io.observe($el);


    // do things
    function handleIoEntry(entries) {
        entries.forEach(entry => {
            if ( 'once' == entry.target.dataset.io ) {
                handleIoOnce(entry);
            } else {
                handleIo(entry);
            }
        });
    }

    function handleIoOnce(entry) {
        if ( entry.isIntersecting && 'true' != entry.target.dataset.ioVisible ) {
            entry.target.dataset.ioVisible = true;

            if ( typeof callbackEnter === 'function' ) {
                callbackEnter();
            }
        }
    }

    function handleIo(entry) {
        if ( entry.isIntersecting ) {
            entry.target.dataset.ioVisible = true;

            if ( typeof callbackEnter === 'function' ) {
                callbackEnter();
            }

            // Start scroll tracking if option is set
            if ( customOptions.viewportY && !entry.target._scrolling ) {
                entry.target._scrolling = true;
                window.addEventListener('scroll', handleIoScroll);
            }
        } else {
            entry.target.dataset.ioVisible = false;

            if ( typeof callbackExit === 'function' ) {
                callbackExit();
            }

            // Stop scroll tracking if option is set
            if ( customOptions.viewportY && entry.target._scrolling ) {
                entry.target._scrolling = false;
                window.removeEventListener('scroll', handleIoScroll);
            }
        }
    }

    function handleIoScroll() {
        const elRect = $el.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // if the element is in the viewport
        if ( elRect.top < viewportHeight && elRect.bottom >= 0 ) {
            const elYTarget = elRect.height * (customOptions.yOffset / 100);
            const viewportTarget = viewportHeight * (customOptions.viewportY / 100);
            const viewportTargetDistancePx = Math.round(elRect.top - viewportTarget + elYTarget);
            let viewportTargetDistancePercent = viewportTargetDistancePx / ((elRect.height + viewportHeight) / 2);
            viewportTargetDistancePercent = Number(viewportTargetDistancePercent.toFixed(3));

            $el.style = `--elmnt-io-y: ${viewportTargetDistancePercent}`;
        }
    }
}
